/* eslint-disable */
export default {
  name: 'assignment-list',
  components: {},
  props: [],
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {

  }
}